export function getTimeDisplayFromDate(value: Date | undefined) {
  return !value
    ? ''
    : value
        .toLocaleTimeString('de-DE', { timeZone: 'Europe/Berlin' })
        .substring(0, 5);
}
